module.exports = __webpack_public_path__ + "assets/img/lef.1af890f7.png";